import { useRef, useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { uploadIntakeAlterationPhoto, getPublicApiOrigin } from '../../lib/api';
import { toast } from 'sonner';
import { ImagePlus, Loader2 } from 'lucide-react';

const ACCEPT = 'image/jpeg,image/png,image/gif,image/webp';

export default function AlterationRowWithPhoto({
  label,
  zone,
  value,
  recordId,
  readOnly,
  onChange,
}) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const entry = value || { description: '', photo: null };
  const photoUrl = entry.photo?.url
    ? `${getPublicApiOrigin()}${entry.photo.url}`
    : null;

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file || !recordId) return;
    setUploading(true);
    try {
      const att = await uploadIntakeAlterationPhoto(recordId, zone, file);
      onChange({
        ...entry,
        photo: {
          id: att.id,
          url: att.url,
          uploaded_at: att.uploaded_at,
        },
      });
      toast.success('Foto guardada');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'No se pudo subir la foto');
    } finally {
      setUploading(false);
    }
  };

  return (
    <tr className="border-t border-border/60 align-top">
      <td className="p-2 font-medium text-sm w-[28%]">{label}</td>
      <td className="p-2">
        <Textarea
          rows={2}
          disabled={readOnly}
          placeholder="Describe"
          value={entry.description || ''}
          onChange={(e) => onChange({ ...entry, description: e.target.value })}
          className="min-h-[4rem] text-sm"
        />
      </td>
      <td className="p-2 w-[100px] text-center">
        {photoUrl ? (
          <a
            href={photoUrl}
            target="_blank"
            rel="noreferrer"
            className="block rounded-lg border overflow-hidden bg-muted/30"
          >
            <img
              src={photoUrl}
              alt={label}
              className="w-20 h-20 object-cover mx-auto"
            />
          </a>
        ) : null}
        {!readOnly && recordId ? (
          <>
            <input
              ref={inputRef}
              type="file"
              accept={ACCEPT}
              className="hidden"
              onChange={handleFile}
            />
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="mt-2 w-full"
              disabled={uploading}
              onClick={() => inputRef.current?.click()}
            >
              {uploading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <ImagePlus className="w-4 h-4" />
              )}
              <span className="sr-only">Foto</span>
            </Button>
          </>
        ) : null}
        {!recordId && !readOnly ? (
          <p className="text-xs text-muted-foreground mt-1">Guarde borrador primero</p>
        ) : null}
      </td>
    </tr>
  );
}
